import { useEffect } from "react";
import * as teams from "@microsoft/teams-js";


export default function B2CPopupStart() {
useEffect(() => {
const run = async () => {
  try {
    // Initialize Teams before using any Teams APIs
    await teams.app.initialize();
    
    // Now we can safely use Teams authentication APIs
    teams.authentication.authenticate({
      url: window.location.origin + "/authend",
      width: 600,
      height: 535,
      successCallback: (token: string) => {},
      failureCallback: (err: string) => console.error(err),
    });
  } catch (err) {
    console.error("Failed to initialize Teams or authenticate:", err);
  }
};

run();
}, []);


return <div>Starting login…</div>;
}